module.exports = __webpack_public_path__ + "img/plan_tratamiento_aprobacion.2889f1ff.png";